import React from 'react';
import Location from './Location';
import WrapComponent from '../WrapComponent';
import Near from './Near';
import './Location.less';

class LocationIndex extends React.Component{
    render(){
        let {form, api_name, default_value, is_required, isMobile} = this.props;
        const {getFieldProps} = form;
        let fieldProps = getFieldProps(api_name, {
            initialValue: default_value,
            validate: [{
                trigger: 'onChange',
                rules: [{
                    required: is_required,
                    message: $st(`该项是必填项`)
                }]
            }]
        })
        let Element = isMobile ? Near : Location;
        return <Element {...this.props} {...fieldProps}></Element>
    }
}

export default WrapComponent(LocationIndex);


// WEBPACK FOOTER //
// ./src/component/Location/index.js